import React from 'react'

import MenuItem from '@mui/material/MenuItem'

import whatsAlongThisIcon from 'img/tools/noun-bezier-4433985.svg'
import whatsWithinThisIcon from 'img/tools/noun-cursor-select-237368.svg'
import whatsThisIcon from 'img/tools/noun-pointing-237378.svg'
import whatsAroundThisIcon from 'img/tools/noun-select-circle-area-591134.svg'
import whatsHereIcon from 'img/tools/noun-target-1447972.svg'

const styles = {
  icon: {
    height: 20,
    marginLeft: -3,
    opacity: 0.5,
    width: 20
  },
  menuItem: {
    columnGap: 8,
    paddingLeft: 10,
    paddingRight: 10
  }
}

interface WhatsHereMenuItemProps {
  onClick: () => void
  menuItemType: string
}

interface MenuItem {
  icon: {
    src: string
    alt: string
  }
  onClick?: () => void
  text: string
  tooltip: string
}

const menuItems: { [key: string]: MenuItem } = {
  whatsAlongThis: {
    icon: {
      src: whatsAlongThisIcon,
      alt: 'bezier curve icon'
    },
    text: 'What\'s along this',
    tooltip: 'Display a list of features along this feature'
  },
  whatsAroundThis: {
    icon: {
      src: whatsAroundThisIcon,
      alt: 'cursor select circle icon'
    },
    text: 'What\'s around this',
    tooltip: 'Display a list of features that are within a specified distance of this feature'
  },
  whatsHere: {
    icon: {
      src: whatsHereIcon,
      alt: 'target icon'
    },
    text: 'What\'s here',
    tooltip: 'Display a list of features at the location of the click'
  },
  whatsThis: {
    icon: {
      src: whatsThisIcon,
      alt: 'pointing icon'
    },
    text: 'What\'s this',
    tooltip: 'Display details about this feature'
  },
  whatsWithinThis: {
    icon: {
      src: whatsWithinThisIcon,
      alt: 'cursor select icon'
    },
    text: 'What\'s within this',
    tooltip: 'Display a list of features that are covered (wholly or partly) by this feature'
  }
}

class WhatsHereMenuItem extends React.Component<WhatsHereMenuItemProps> {
  render () {
    const { menuItemType, onClick } = this.props

    return (
      <MenuItem
        style={styles.menuItem}
        key={menuItems[menuItemType].text}
        onClick={onClick}
        title={menuItems[menuItemType].tooltip}
      >
        <img
          style={styles.icon}
          src={menuItems[menuItemType].icon.src}
          alt={menuItems[menuItemType].icon.alt}
        />
        {menuItems[menuItemType].text}
      </MenuItem>
    )
  }
}

export default WhatsHereMenuItem
